import { render, staticRenderFns } from "./product-review.vue?vue&type=template&id=709f86aa&scoped=true"
import script from "./product-review.vue?vue&type=script&lang=js"
export * from "./product-review.vue?vue&type=script&lang=js"
import style0 from "./product-review.vue?vue&type=style&index=0&id=709f86aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f86aa",
  null
  
)

export default component.exports